import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const stats = [
  { value: "12,800+", label: "社区邻居" },
  { value: "3,600+", label: "互动帖子" },
  { value: "1,200+", label: "服务信息" },
];

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden rounded-lg">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20friendly%20neighborhood%20with%20cozy%20houses%2C%20green%20trees%2C%20people%20walking%20and%20chatting%2C%20soft%20orange%20sunset%20tones%2C%20stylized%20flat%20art%20style%2C%20welcoming%20harmonious%20community%20atmosphere&width=1920&height=1080&seq=hero-community-01&orientation=landscape"
        alt="温馨的社区场景插画"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>

      <div className="relative w-full h-full flex flex-col items-center justify-center text-center px-4">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium mb-5">
          <i className="ri-home-heart-line"></i> 本地社区交流平台
        </span>
        <h1 className="text-2xl md:text-5xl font-bold text-white leading-tight max-w-3xl">
          邻居，让邻里关系更近一步
        </h1>
        <p className="text-sm md:text-lg text-white/85 mt-4 max-w-2xl leading-relaxed">
          了解身边新闻与活动，参与邻里互动，查找生活服务信息，一起打造和谐温暖的社区。
        </p>

        <form onSubmit={handleSearch} className="w-full max-w-xl mt-7">
          <div className="flex items-center gap-2 bg-background-50 rounded-full p-1.5 border border-background-300">
            <i className="ri-search-line text-foreground-400 text-lg ml-3"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索社区新闻、论坛帖子或生活服务"
              className="flex-1 h-10 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              搜索
            </button>
          </div>
        </form>

        <div className="flex items-center gap-6 md:gap-10 mt-8 text-white">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-lg md:text-2xl font-bold">{s.value}</p>
              <p className="text-xs text-white/70 mt-0.5">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}